import React, { PropTypes } from 'react';
import makeArray from 'utils/makeArray';
import cx from './Spinner.scss';

const sizes = {
  xs: 20,
  s: 40,
  m: 84,
  l: 120,
};

const squares = makeArray(2);
const lines = makeArray(4);

import withStyles from 'decorators/withStyles';

@withStyles(cx)
export default class Spinner extends React.Component {
  static propTypes = {
    size: PropTypes.oneOf(Object.keys(sizes)),
    color: PropTypes.string,
    style: PropTypes.object,
  };

  render() {
    const {
      size = 'm',
      color = '#2AB8D5',
      style = {},
      ...props,
    } = this.props;
    const width = sizes[size];
    const height = width * 0.68;
    const small = size === 's' || size === 'xs';

    return (
      <div
        className={cx('main')}
        style={{
          ...style,
          width: height,
          height,
          margin: `0 ${Math.round(height / 2)}px`,
        }}
        {...props}
      >
        <div className={cx('w')}>
          {squares.map(j =>
            <div key={j} className={cx('sq', [j + 1])}>
              {lines.map(i =>
                <div
                  key={i}
                  className={cx('line', [i + 1])}
                  style={{
                    backgroundColor: color,
                  }}
                >
                  <div
                    className={cx('dot', { small })}
                    style={{
                      backgroundColor: color,
                    }}
                    />
                  <div
                    className={cx('dot', { small })}
                    style={{
                      backgroundColor: color,
                    }}
                    />
                </div>
              )}
            </div>
          )}
        </div>

        <div className={cx('w')}>
          {squares.map(j =>
            <div key={j} className={cx('sq', [j + 1])}>
              {lines.map(i =>
                <div
                  key={i}
                  className={cx('line', [i + 1])}
                  style={{
                    backgroundColor: color,
                  }}
                >
                  <div
                    className={cx('dot', { small })}
                    style={{
                      backgroundColor: color,
                    }}
                    />
                  <div
                    className={cx('dot', { small })}
                    style={{
                      backgroundColor: color,
                    }}
                    />
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/react/components/Spinner/Spinner.js